import { defineMessages } from 'react-intl';

export const messages: {
	noOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noOptions: {
		id: 'noOptions',
		defaultMessage: 'No options',
		description: 'Text shown when there are no filter options matching the search query',
	},
});
